import React from "react";
import { imageCodes, titleCodes, textCodes } from "../../template_codes/cetaphilmm/about_page_codes";

function About() {
    return (
        <div>
            {/*                     about us section                    */}
            <div className="container grid grid-cols-1 xl:grid-cols-2 pt-16 w-5/6 h-4/6">
                <div className="pt-4 xl:pr-8 lg:pr-8">
                    <h1 className="text-lg font-semibold xl:pb-8 pb-4 text-[#004987]">{titleCodes.storyTitle.title}</h1>
                    <p className="pt-4 text-justify">{textCodes.story1.text}</p>
                    <p className="pt-4 text-justify">{textCodes.story2.text}</p>
                    <p className="pt-4 text-justify">{textCodes.story3.text}</p>
                    <p className="pt-4 pb-4 text-justify">{textCodes.story4.text}</p>
                </div>
                <div className="grid grid-cols-2">
                    <div>
                        <img src={imageCodes.heropd2.image} alt="hero product"></img>
                    </div>
                    <div>
                        <img src={imageCodes.heropd1.image} alt="hero product"></img>
                    </div>
                    <div>
                        <img src={imageCodes.heropd3.image} alt="hero product"></img>
                    </div>
                    <div>
                        <img src={imageCodes.heropd4.image} alt="hero product"></img>
                    </div>
                </div>
            </div>
            {/*                     end of about us section                    */}
        </div>
    );
}

export default About;